import { Injectable } from '@angular/core'
import { FacetService, ProductFacetService } from '@spartacus/storefront'
import { BehaviorSubject, Observable } from 'rxjs'
import { EbFacet } from '../../../interfaces/eb-product.interface'

@Injectable()
export class EbFacetService extends FacetService {
  showResetFiltersMessage$ = new BehaviorSubject(false)

  constructor(productFacetService: ProductFacetService) {
    super(productFacetService)
  }

  static getUniqueFacets(facets: EbFacet[]): EbFacet[] {
    return facets?.filter(
      (facet, index, self) => self.findIndex(testFacet => testFacet.code === facet.code) === index
    )
  }

  private static getQueryCodeRegexpPattern(facet: EbFacet) {
    return `:${facet.code}:[^:]+`
  }

  setResetFiltersMessageVisibility(isVisible: boolean) {
    this.showResetFiltersMessage$.next(isVisible)
  }

  isResetFiltersMessageVisible(): Observable<boolean> {
    return this.showResetFiltersMessage$ as Observable<boolean>
  }

  getQueryWithoutFacet(facet: EbFacet) {
    const regexp = new RegExp(EbFacetService.getQueryCodeRegexpPattern(facet), 'g')
    return facet.values?.[0]?.query?.query?.value.replace(regexp, '')
  }

  checkQueryHasFacet(query: string, facet: EbFacet): boolean {
    const re = new RegExp(EbFacetService.getQueryCodeRegexpPattern(facet))
    return re.test(query)
  }
}
